import { Stack } from '@mui/material'
import Header from '../components/Header/Header'
import UsersList from '../components/Users/UsersList'

export default function Users() {
  return (
    <>
      <Header />
      <Stack direction='column' padding={'100px'} alignItems='flex-start' justifyContent='flex-start'>
        <UsersList />
      </Stack>
    </>
  )
}
